import { ArrowRight, LockKeyhole } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Seo from "../components/Seo";
import { useAuth } from "../context/AuthContext";
import { apiErrorMessage } from "../utils/apiError";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email, password, rememberMe);
      navigate("/app");
    } catch (requestError: unknown) {
      setError(apiErrorMessage(requestError, "E-mailadres of wachtwoord is onjuist."));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="auth-page">
      <Seo
        title="Inloggen"
        path="/inloggen"
        description="Log veilig in bij DeVerlofkaart."
        noIndex
      />
      <div className="auth-shell">
        <div className="auth-message">
          <span>
            <LockKeyhole size={22} />
          </span>
          <p className="eyebrow">Welkom terug</p>
          <h1>Je verlofjaar staat voor je klaar.</h1>
          <p>
            Open je persoonlijke planning of ga verder met aanvragen en fiattering in je
            organisatie.
          </p>
        </div>
        <form className="auth-form surface" onSubmit={onSubmit}>
          <div>
            <h2>Inloggen</h2>
            <p>Gebruik het e-mailadres van je account.</p>
          </div>
          <label>
            <span>E-mailadres</span>
            <input
              autoComplete="email"
              placeholder="naam@voorbeeld.nl"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoFocus
            />
          </label>
          <button
            className="login-remember-toggle"
            type="button"
            role="switch"
            aria-checked={rememberMe}
            onClick={() => setRememberMe((current) => !current)}
          >
            <span aria-hidden="true" className="login-remember-track">
              <i />
            </span>
            Ingelogd blijven
          </button>
          <label>
            <span>Wachtwoord</span>
            <input
              autoComplete="current-password"
              placeholder="Je wachtwoord"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          {error && (
            <p className="form-error" role="alert">
              {error}
            </p>
          )}
          <button
            className="button primary full-width"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Inloggen..." : "Inloggen"}
            <ArrowRight size={17} />
          </button>
          <p className="auth-footnote">
            Nog geen account? <Link to="/registreren">Gratis registreren</Link>
          </p>
        </form>
      </div>
    </section>
  );
}
